import {
  Shield,
  FileText,
  CheckCircle,
  Users,
  Handshake,
  BookOpen,
  ShoppingCart,
  Rocket,
  Cookie,
  type LucideIcon,
} from "lucide-react";

export interface LegalDocument {
  title: string;
  href: string;
  icon: LucideIcon;
}

export interface LegalDocumentsGroup {
  label: string;
  documents: LegalDocument[];
}

export type AppKey = "buddify" | "ai-assistant" | "marketplace";

export interface AppConfig {
  key: AppKey;
  label: string;
  color: "primary" | "secondary" | "tertiary";
}

export const apps: AppConfig[] = [
  { key: "buddify", label: "Buddify", color: "primary" },
  { key: "ai-assistant", label: "Buddy AI Assistant", color: "secondary" },
  { key: "marketplace", label: "Marketplace", color: "tertiary" },
];

export const legalDocuments: Record<
  AppKey,
  LegalDocument[] | LegalDocumentsGroup[]
> = {
  buddify: [
    {
      label: "For Merchants",
      documents: [
        {
          title: "Privacy Policy",
          href: "/brand-partnerships/privacy",
          icon: Shield,
        },
        {
          title: "Terms of Use",
          href: "/brand-partnerships/terms",
          icon: FileText,
        },
        {
          title: "Acceptable Use Policy",
          href: "/brand-partnerships/acceptable-use",
          icon: CheckCircle,
        },
        {
          title: "Community Guideline",
          href: "/brand-partnerships/community-guideline",
          icon: Users,
        },
      ],
    },
    {
      label: "General",
      documents: [
        {
          title: "Cookie Policy",
          href: "/cookie",
          icon: Cookie,
        },
      ],
    },
  ],
  "ai-assistant": [
    {
      title: "Privacy Policy",
      href: "/buddy-ai-assistant/privacy",
      icon: Shield,
    },
    {
      title: "Terms of Use",
      href: "/buddy-ai-assistant/terms",
      icon: FileText,
    },
  ],
  marketplace: [
    {
      label: "For Merchants",
      documents: [
        {
          title: "Seller Agreement",
          href: "/marketplace/seller-agreement",
          icon: Handshake,
        },
        {
          title: "Guidelines for Participation",
          href: "/marketplace/guidelines-for-participation",
          icon: BookOpen,
        },
        {
          title: "How to Join?",
          href: "/marketplace#how-it-works",
          icon: Rocket,
        },
      ],
    },
    {
      label: "For Customers",
      documents: [
        {
          title: "Privacy Policy",
          href: "/marketplace/privacy",
          icon: Shield,
        },
        {
          title: "Terms and Conditions",
          href: "/marketplace/terms",
          icon: FileText,
        },
        {
          title: "Customer Purchase Agreement",
          href: "/marketplace/customer-purchase-agreement",
          icon: ShoppingCart,
        },
      ],
    },
  ],
};

// Type guard to check if documents are grouped
export function isGroupedDocuments(
  docs: LegalDocument[] | LegalDocumentsGroup[]
): docs is LegalDocumentsGroup[] {
  return docs.length > 0 && "label" in docs[0];
}
